import React, { useState, useEffect } from 'react';

const reviews = [
  '/images/review-1.jpg',
  '/images/review-2.jpg',
  '/images/review-3.jpg',
  '/images/review-4.jpg'
];

const ReviewSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-play logic
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 4000); 
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length);
  };

  const scrollToOrder = () => {
    document.getElementById("order").scrollIntoView({ behavior: "smooth" });
  };

  const nextIndex = (currentIndex + 1) % reviews.length;

  return (
    <section className="bg-gradient-to-br from-[#F2FBF5] via-[#FCFDFD] to-[#EAF7ED] py-16 md:py-24 px-4 relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        
        {/* Minimal Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-1.5 rounded-full text-sm font-semibold mb-4 tracking-wide shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            Review & Trust
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight leading-tight">
            সন্তুষ্ট কাস্টমারদের মতামত
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            হাজারো পরিবার ইতিমধ্যে আমাদের পণ্য ব্যবহার করছেন এবং তাদের বাচ্চাদের পুষ্টি নিশ্চিত করছেন।
          </p>
        </div>

        {/* Minimal Trust Badges */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-5 md:gap-16 mb-16 md:mb-20">
          <div className="flex flex-col items-center text-center">
             <div className="bg-green-50 p-2 md:p-3 rounded-full text-green-600 mb-1.5 md:mb-3 border border-green-100 shadow-sm">
               <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-7 md:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                 <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
               </svg>
             </div>
             <span className="font-extrabold text-gray-900 text-[16px] md:text-xl mb-0.5 md:mb-1">৩০০০০+ সন্তুষ্ট কাস্টমার</span>
             <p className="text-[12px] md:text-sm text-gray-500 font-medium">দেশজুড়ে আমাদের নেটওয়ার্ক</p>
          </div>
          
          <div className="hidden md:block w-px h-16 bg-gray-200"></div>

          <div className="flex flex-col items-center text-center">
             <div className="bg-yellow-50 p-2 md:p-3 rounded-full text-yellow-500 mb-1.5 md:mb-3 border border-yellow-100 shadow-sm">
               <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-7 md:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                 <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
               </svg>
             </div>
             <span className="font-extrabold text-gray-900 text-[16px] md:text-xl mb-0.5 md:mb-1">৪.৯/৫ গড় রেটিং</span>
             <p className="text-[12px] md:text-sm text-gray-500 font-medium">কাস্টমারদের বিশ্বস্ততার প্রমাণ</p>
          </div>
          
          <div className="hidden md:block w-px h-16 bg-gray-200"></div>

          <div className="flex flex-col items-center text-center">
             <div className="bg-blue-50 p-2 md:p-3 rounded-full text-blue-500 mb-1.5 md:mb-3 border border-blue-100 shadow-sm">
               <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-7 md:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                 <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
               </svg>
             </div>
             <span className="font-extrabold text-gray-900 text-[16px] md:text-xl mb-0.5 md:mb-1">৯৪% রিপিট অর্ডার</span>
             <p className="text-[12px] md:text-sm text-gray-500 font-medium">অর্ডার করছেন বারবার</p>
          </div>
        </div>

        {/* Minimal Clean Slider */}
        <div className="relative max-w-5xl mx-auto px-4 md:px-14 mb-16 group">
          {/* Controls - Elegant Floating Action Buttons */}
          <button 
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white text-gray-600 hover:text-green-600 p-3 rounded-full shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-gray-100 transition-all duration-300 md:opacity-0 md:group-hover:opacity-100 -translate-x-3 md:-translate-x-6"
            aria-label="Previous Slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
          </button>
          
          <div className="overflow-hidden relative w-full">
             <div className="flex transition-transform duration-700 ease-[cubic-bezier(0.25,1,0.5,1)] gap-6 justify-center">
                 {/* Mobile single view */}
                 <div className="block md:hidden shrink-0 w-full animate-fadeIn">
                   <img 
                     src={reviews[currentIndex]} 
                     alt={`Review ${currentIndex + 1}`} 
                     className="w-full h-auto aspect-[4/5] object-cover object-top rounded-3xl shadow-md ring-1 ring-gray-900/5 mx-auto"
                   />
                 </div>
                 
                 {/* Desktop double view */}
                 <div className="hidden md:flex w-full shrink-0 gap-8 animate-fadeIn">
                   <div className="w-1/2 group/image overflow-hidden rounded-3xl shadow-sm hover:shadow-xl ring-1 ring-gray-900/5 bg-white transition-all duration-300">
                     <img 
                       src={reviews[currentIndex]} 
                       alt={`Review ${currentIndex + 1}`} 
                       className="w-full h-[450px] object-cover object-top transition-transform duration-700 group-hover/image:scale-105"
                     />
                   </div>
                   <div className="w-1/2 group/image overflow-hidden rounded-3xl shadow-sm hover:shadow-xl ring-1 ring-gray-900/5 bg-white transition-all duration-300">
                     <img 
                       src={reviews[nextIndex]} 
                       alt={`Review ${nextIndex + 1}`} 
                       className="w-full h-[450px] object-cover object-top transition-transform duration-700 group-hover/image:scale-105"
                     />
                   </div>
                 </div>
             </div>
          </div>

          <button 
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white text-gray-600 hover:text-green-600 p-3 rounded-full shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-gray-100 transition-all duration-300 md:opacity-0 md:group-hover:opacity-100 translate-x-3 md:translate-x-6"
            aria-label="Next Slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </button>
          
          {/* Subtle Dots Indicator */}
          <div className="flex justify-center items-center gap-2 mt-10">
            {reviews.map((_, idx) => (
              <button 
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`transition-all duration-500 rounded-full ${
                  currentIndex === idx ? 'w-8 h-2.5 bg-green-500' : 'w-2.5 h-2.5 bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        {/* High-End CTA Button */}
        <button
          onClick={scrollToOrder}
          className="relative group w-[90%] sm:w-full max-w-sm mx-auto block text-center mt-4 rounded-xl transition-transform duration-300 hover:-translate-y-1"
        >
          {/* Base metallic gradient & shadow layer */}
          <div className="absolute inset-0 bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-600 rounded-xl shadow-[0_8px_20px_rgba(202,138,4,0.4)] sm:shadow-[0_10px_30px_rgba(202,138,4,0.5)] group-hover:shadow-[0_12px_25px_rgba(202,138,4,0.6)] sm:group-hover:shadow-[0_15px_40px_rgba(202,138,4,0.7)] transition-shadow duration-300"></div>
          
          {/* Metallic Top Glare */}
          <div className="absolute top-0 inset-x-0 h-1/2 bg-gradient-to-b from-white/60 to-transparent rounded-t-xl pointer-events-none"></div>
          
          {/* Bottom Reflection */}
          <div className="absolute bottom-0 inset-x-0 h-1/4 bg-gradient-to-t from-black/10 to-transparent rounded-b-xl pointer-events-none"></div>

          {/* Animated Shine Effect */}
          <div className="absolute inset-0 overflow-hidden rounded-xl">
             <div className="absolute inset-0 -translate-x-[150%] group-hover:translate-x-[150%] transition-transform duration-1000 ease-in-out bg-gradient-to-r from-transparent via-white/60 to-transparent w-full skew-x-[-20deg]"></div>
          </div>

          {/* Button Content */}
          <div className="relative flex items-center justify-center gap-2 sm:gap-3 py-3 sm:py-4 px-3 sm:px-6 border border-white/50 rounded-xl">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="w-5 h-5 sm:w-8 sm:h-8 text-green-900 drop-shadow-sm">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
            </svg>
            <span className="text-green-900 font-extrabold text-[16px] min-[375px]:text-[17px] sm:text-2xl tracking-wide drop-shadow-sm">
              আপনিও অর্ডার করুন
            </span>
          </div>
        </button>

      </div>
    </section>
  );
};

export default ReviewSection;
